// A placeholder for the call ended screen
// We can use this page to show the status or run logic after call was ended
const VideoCallCompleted = () => {
  return (
    <div className="bg-surface-subdued text-on-surface flex h-screen w-screen items-center justify-center">
      Meeting room was ended
    </div>
  )
}

export { VideoCallCompleted }
